import { FormikProps } from "formik";
import _ from "lodash";

import { colors } from "theme/palette";

import Button from "components/Button";
import Stack from "components/Stack";

import { ETransactionDialogStatus } from "pages/Deal/FinancingEvents/constants";
import TransactionDebtModifyForm from "pages/Deal/FinancingEvents/TransactionModifyDialog/TransactionForm/TransactionDebtModifyForm";
import TransactionEquityModifyForm from "pages/Deal/FinancingEvents/TransactionModifyDialog/TransactionForm/TransactionEquityModifyForm";
import TransactionGeneralInformationForm from "pages/Deal/FinancingEvents/TransactionModifyDialog/TransactionForm/TransactionGeneralInfoForm";
import TransactionGrantModifyForm from "pages/Deal/FinancingEvents/TransactionModifyDialog/TransactionForm/TransactionGrantModifyForm";
import TransactionOtherModifyForm from "pages/Deal/FinancingEvents/TransactionModifyDialog/TransactionForm/TransactionOtherModifyForm";
import TransactionTaxCreditAllocationModifyForm from "pages/Deal/FinancingEvents/TransactionModifyDialog/TransactionForm/TransactionTaxCreditAllocationModifyForm";

import { ETransactionType } from "entities/Deal/constants";
import { ITransactionValuesForm } from "entities/Deal/sdk";

export interface ITransactionForm {
  formik: FormikProps<ITransactionValuesForm>;
  transactionDialogStatus: ETransactionDialogStatus;
  previousTransactionType: ETransactionType | null;
  onDialogClose: () => void;
  lastUpdatedInformation: string | null;
  onNextButtonClickHandler?: () => void;
  onUpdateButtonClickHandler?: () => void;
  onBackButtonClickHandler?: () => void;
  transactionIdentifier?: string;
}

const TransactionForm = ({
  formik,
  transactionDialogStatus,
  previousTransactionType,
  onDialogClose,
  lastUpdatedInformation,
  onNextButtonClickHandler,
  onUpdateButtonClickHandler,
  onBackButtonClickHandler,
  transactionIdentifier,
}: ITransactionForm) => {
  return (
    <form onSubmit={formik.handleSubmit}>
      {transactionDialogStatus === ETransactionDialogStatus.GENERAL_INFO && (
        <>
          <TransactionGeneralInformationForm
            formik={formik}
            previousTransactionType={previousTransactionType}
            lastUpdatedInformation={lastUpdatedInformation}
            transactionIdentifier={transactionIdentifier}
          />
          <Stack
            borderTop={1}
            borderColor={colors.gray20}
            flexDirection="row"
            justifyContent="flex-end"
            gap={1}
            padding={2}
            position="sticky"
            bottom="0"
            sx={{ backgroundColor: colors.white, zIndex: 2 }}
          >
            <Button color="secondary" variant="text" onClick={onDialogClose}>
              Cancel
            </Button>

            {!_.isNil(onNextButtonClickHandler) && (
              <Button
                color="primary"
                onClick={onNextButtonClickHandler}
                disabled={formik.isSubmitting}
              >
                Next
              </Button>
            )}
            {!_.isNil(onUpdateButtonClickHandler) && (
              <Button
                color="primary"
                onClick={onUpdateButtonClickHandler}
                disabled={formik.isSubmitting}
              >
                Update
              </Button>
            )}
          </Stack>
        </>
      )}
      {transactionDialogStatus === ETransactionDialogStatus.SPECIFIC_INFO && (
        <>
          {formik.values.transaction_type ===
            ETransactionType.EQUITY_TRANSACTION && (
            <TransactionEquityModifyForm
              formik={formik}
              lastUpdatedInformation={lastUpdatedInformation}
              transactionIdentifier={transactionIdentifier}
            />
          )}
          {formik.values.transaction_type ===
            ETransactionType.DEBT_TRANSACTION && (
            <TransactionDebtModifyForm
              formik={formik}
              lastUpdatedInformation={lastUpdatedInformation}
              transactionIdentifier={transactionIdentifier}
            />
          )}
          {formik.values.transaction_type ===
            ETransactionType.TAX_CREDIT_ALLOCATION_TRANSACTION && (
            <TransactionTaxCreditAllocationModifyForm
              formik={formik}
              lastUpdatedInformation={lastUpdatedInformation}
              transactionIdentifier={transactionIdentifier}
            />
          )}
          {formik.values.transaction_type ===
            ETransactionType.GRANT_TRANSACTION && (
            <TransactionGrantModifyForm
              formik={formik}
              lastUpdatedInformation={lastUpdatedInformation}
              transactionIdentifier={transactionIdentifier}
            />
          )}
          {formik.values.transaction_type ===
            ETransactionType.OTHER_TRANSACTION && (
            <TransactionOtherModifyForm
              formik={formik}
              lastUpdatedInformation={lastUpdatedInformation}
              transactionIdentifier={transactionIdentifier}
            />
          )}

          <Stack
            borderTop={1}
            borderColor={colors.gray20}
            flexDirection="row"
            justifyContent="flex-end"
            gap={1}
            padding={2}
            position="sticky"
            bottom="0"
            sx={{ backgroundColor: colors.white, zIndex: 2 }}
          >
            <Button onClick={onDialogClose} color="secondary" variant="text">
              Cancel
            </Button>

            {!_.isNil(onNextButtonClickHandler) && (
              <>
                <Button
                  sx={{
                    backgroundColor: colors.white,
                    color: colors.gray40,
                    border: 1,
                  }}
                  onClick={onBackButtonClickHandler}
                >
                  Back
                </Button>
                <Button
                  color="primary"
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  Create
                </Button>
              </>
            )}
            {!_.isNil(onUpdateButtonClickHandler) && (
              <>
                <Button
                  color="primary"
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  Update
                </Button>
              </>
            )}
          </Stack>
        </>
      )}
    </form>
  );
};

export default TransactionForm;
